export default __webpack_public_path__ + "966a87d9c05375dd494a2ec5be78429b.png";